var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWindowSeat(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 19
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(1)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12.05,
    cy: 2.25,
    r: 2.25,
    fill: "#647A97",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#647A97",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M8.205 14.044s4.109.7 4.152-1.84c.043-2.54 0-5.94 0-5.94M8.888 17.227s5.342 1.04 6.025-1.216c.683-2.256 1.82-7.18 1.82-7.18"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6.585,
    height: 9.054,
    x: 0.823,
    y: 0.823,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    width: 8.231,
    height: 10.7,
    stroke: "#647A97",
    strokeWidth: 2,
    rx: 3
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#647A97",
    d: "M2.736 4.004l3.925 3.925M2.736 6.704l2.25 2.25"
  }))));
}
export default SvgWindowSeat;